import { FULL_NAME } from "helpers/common";
import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Formik } from 'formik';
import * as Yup from 'yup';

const CreateTemplatePopup = ({ showPopup, closePopup, onSubmit }) => {

  const validation = Yup.object({
    template_name: Yup.string().required("Template name is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setSubmitting(true);
      await onSubmit(values.template_name);
      setSubmitting(false);
      closePopup();
    } catch(error) {
      console.log("Error creating template", error);
      setSubmitting(false);
    }
  }

  return (
    <>
    <Formik
      initialValues={{
        template_name: ""
      }}
      enableReinitialize
      validationSchema={validation}
      onSubmit={handleSubmit}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
      }) => (
      <Modal
        show={showPopup}
        onHide={closePopup}
        backdrop="static"
        keyboard={false}
        centered
        className="FormPop"
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Template</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-lg-5 pt-0">
          <Form onSubmit={handleSubmit}>
          <Row className="">
            <Col lg="8" className="my-4">              
              <label htmlFor="" className="form-label m-0 fw-sbold">
                Template Name
              </label>
              <input
                type="text"
                name="template_name"
                className={`form-control ${errors.template_name && "is-invalid"}`}
                onBlur={handleBlur}
                onChange={handleChange}
              />
              {errors.template_name && touched.template_name && (
                <p className="invalid-feedback">{errors.template_name}</p>
              )}
            </Col>
            <Col lg="12" className="FormbtnWrpper justify-content-start d-flex gap-10">
              <Button
                type="submit"
                disabled={isSubmitting}
                className="d-flex align-items-center justify-content-center commonBtn btnSm"
              >
                {isSubmitting ? "Please wait..." : "Submit"}
              </Button>
              <Button
                className="d-flex align-items-center justify-content-center commonBtn btnSm"
                onClick={closePopup}
              >
                Cancel
              </Button>
            </Col>
          </Row>
          </Form>
        </Modal.Body>
      </Modal>
      )}
      </Formik>
    </>
  );
};



export default CreateTemplatePopup;
